import React, { memo, useMemo } from 'react';
// import Iconfont from '@gp/components/Iconfont';
import { getFormatPercentPlus, isValidNumber } from '@gp/utils/common';
import classNames from 'classnames';
import './index.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';

type ORG = {
  percent: string;
  tendency: 'up' | 'down' | 'flat';
};
interface PercentTendencyFloatPropsType {
  className?: string;
  style?: React.CSSProperties;
  value: number | string;
  decimal?: number; // 保留多少位小数
}

const ICON_TYPE_MAP: { [keyName: string]: string } = {
  up: 'green-up-new',
  down: 'red-down-new',
};
const DEFAULT_PROPS: PercentTendencyFloatPropsType = {
  className: '',
  style: {},
  value: '',
  decimal: 0,
};

/**
 * 目前GP系统:
 * 上升下降百分比最大展示“9999%+(不保留小数)”
 * 正常百分比最大展示“99999(加上保留多少位小数)%+”
 */
function PercentTendencyFloat(props: PercentTendencyFloatPropsType) {
  const { className, style, value, decimal } = props;

  const org: ORG = useMemo(() => {
    const v: number = Number(value);
    let res: ORG = {
      percent: '0',
      tendency: 'flat',
    };
    if (!isValidNumber(v)) {
      return res;
    } else {
      const abs = Math?.abs(v);
      const temp = Math?.round(abs * 100);
      const beyondMax = String(temp)?.length > 4;
      res.percent =
        temp > 0
          ? beyondMax
            ? '9999%+'
            : getFormatPercentPlus(abs, decimal)
          : '0';
      switch (true) {
        case v === 0:
          res.tendency = 'flat';
          break;
        case v > 0:
          res.tendency = 'up';
          break;
        case v < 0:
          res.tendency = 'down';
          break;
        default:
          res.tendency = 'flat';
          break;
      }

      return res;
    }
  }, [value]);

  return (
    <div
      className={classNames({
        'dbg-percent-tendency-float': true,
        [className as string]: !!className,
        'tendency-up': org.tendency === 'up',
        'tendency-down': org.tendency === 'down',
      })}
      style={style}
    >
      {isValidNumber(value) ? org?.percent : ''}
      {ICON_TYPE_MAP?.[org?.tendency] ? (
        <SvgIcon className='dbg-percent-tendency-float-icon' type={ICON_TYPE_MAP?.[org?.tendency]} />
      ) : (
        <i>-</i>
      )}
    </div>
  );
}

PercentTendencyFloat.defaultProps = DEFAULT_PROPS;

export default memo(PercentTendencyFloat);
